import type { Component } from 'vue'
import { Coins, KeyRound, ShieldCheck, UserRound } from 'lucide-vue-next'
import AccountOverviewTab from './AccountOverviewTab.vue'
import AccountInfoTab from './AccountInfoTab.vue'
import AccountPasswordTab from './AccountPasswordTab.vue'
import AccountRechargeTab from './AccountRechargeTab.vue'

/**
 * 账号弹窗（左下角用户）的可选分节。
 * 基础包提供全部基础分节，各业务模块通过 ModuleConfig.accountSections 选择要显示哪些。
 * - 单用户模块：默认 基础信息 / 修改信息 / 修改密码。
 * - 多用户模块：在上面基础上追加 点数充值（recharge）。
 *
 * 分节组件同步引入：这些面板很小且随 base 一并加载；若改为异步组件，切换分节时
 * 会有一帧「面板为空」导致弹窗高度瞬间塌缩（闪烁）。
 */
export interface AccountSectionDef {
  key: string
  /** i18n key（base 公共词条 shell.account.tab*） */
  labelKey: string
  icon: Component
  component: Component
}

export const ACCOUNT_SECTIONS: AccountSectionDef[] = [
  {
    key: 'account',
    labelKey: 'shell.account.tabAccount',
    icon: UserRound,
    component: AccountOverviewTab,
  },
  {
    key: 'info',
    labelKey: 'shell.account.tabInfo',
    icon: ShieldCheck,
    component: AccountInfoTab,
  },
  {
    key: 'password',
    labelKey: 'shell.account.tabPassword',
    icon: KeyRound,
    component: AccountPasswordTab,
  },
  {
    key: 'recharge',
    labelKey: 'shell.account.tabRecharge',
    icon: Coins,
    component: AccountRechargeTab,
  },
]

/** 缺省分节：基础信息 / 修改信息 / 修改密码（单用户模块无点数充值） */
export const DEFAULT_ACCOUNT_SECTIONS = ['account', 'info', 'password']

export function resolveAccountSections(keys?: string[]): AccountSectionDef[] {
  const list = keys && keys.length ? keys : DEFAULT_ACCOUNT_SECTIONS
  return ACCOUNT_SECTIONS.filter((s) => list.includes(s.key))
}
